import { render, staticRenderFns } from "./WhatsAppMessages.vue?vue&type=template&id=71432b13&scoped=true&"
import script from "./WhatsAppMessages.vue?vue&type=script&lang=js&"
export * from "./WhatsAppMessages.vue?vue&type=script&lang=js&"
import style0 from "./WhatsAppMessages.vue?vue&type=style&index=0&id=71432b13&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71432b13",
  null
  
)

export default component.exports